import * as React from "react";
import { ChevronDown, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function EmpowermentFramework() {
  const areas = ["Ottawa", "Kanata", "Orleans", "Barrhaven", "Nepean", "Gloucester", "Stittsville"];
  const badges = ["Fully Insured", "Transparent Pricing", "Same-Day Service"];
  return <section data-section-id="235575" id="fair-transparent-pricing" className="bg-background text-foreground relative min-h-screen flex flex-col justify-center overflow-hidden py-24">
      {}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 w-[500px] h-[500px] md:w-[800px] md:h-[800px] bg-primary/10 blur-[120px] rounded-lg pointer-events-none" />

      {}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 md:translate-x-1/3 w-[600px] h-[600px] md:w-[1000px] md:h-[1000px] opacity-90 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_truck_pricing_visual.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_truck_pricing_visual.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_truck_pricing_visual.png-wvc-sizes" alt="Professional JUNKR truck load-level pricing visual for Ottawa" className="w-full h-full object-contain" loading="lazy" decoding="async" />
      </div>

      {}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10 w-full">
        <div className="max-w-3xl">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold font-default tracking-tighter text-primary mb-6 leading-[1.05]">
            Transparent Pricing. <br className="hidden sm:block" />
            No Hidden Fees. <br className="hidden sm:block" />
            Same-Day Available.
          </h1>

          <div className="mb-8">
            <p className="text-sm font-mono uppercase tracking-widest text-muted-foreground mb-3">Serving Local Areas:</p>
            <div className="flex flex-wrap gap-x-4 gap-y-2 text-foreground/80 font-medium">
              {areas.map((area, i) => <span key={area} data-index={i} className="flex items-center gap-1.5">
                  <span className="size-1.5 rounded-lg bg-secondary" />
                  {area}
                </span>)}
            </div>
          </div>
          
          <p className="text-lg sm:text-xl text-muted-foreground mb-10 max-w-2xl leading-relaxed font-default">
            No hidden fees or surprise surcharges. At JUNKR, we price by the volume your items take up in our modern trucks. From a single appliance to a full estate cleanout in Ottawa, you only pay for the space you use.
          </p>

          <div className="flex flex-wrap gap-3 mb-12">
            {badges.map((badge, i) => <div key={badge} data-index={i} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-lg bg-primary text-primary-foreground text-sm font-semibold shadow-sm border border-primary/20">
                <CircleCheck className="size-4 text-secondary" />
                {badge}
              </div>)}
          </div>
          
          <div className="flex flex-wrap items-center gap-4">
            <Button size="lg" asChild className="bg-secondary text-secondary-foreground hover:opacity-90 rounded-lg shadow-md px-8 h-14 text-base font-default font-bold border-none">
              <Link to="/PricingPage">Text us photos for instant estimate</Link>
            </Button>
            <Button size="lg" variant="outline" asChild className="rounded-lg px-8 h-14 text-base border-border hover:bg-accent hover:text-accent-foreground font-default">
              <Link to="/AboutPage">How We Estimate</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 animate-bounce">
        <span className="text-[10px] font-semibold tracking-widest uppercase text-muted-foreground font-default">
          See load levels
        </span>
        <ChevronDown className="size-5 text-muted-foreground" />
      </div>
    </section>;
}